(function() {
    'use strict';
    
    angular
        .module('sideApp')
        .controller('AutoevaluacionController', AutoevaluacionController);

    AutoevaluacionController.$inject = ['$scope', '$state', 'CuestionarioService', 'ParseLinks', 'AlertService'];

    function AutoevaluacionController ($scope, $state, CuestionarioService, ParseLinks, AlertService) {
    	var vm = this;
    	vm.show = 0;
    	vm.save = save;
    	vm.resuelto = null;
    	vm.anterior = anterior;
    	vm.siguiente = siguiente;
    	vm.validarseccion = validarseccion;
    	vm.valido = false;
    	vm.mensaje = null;
    	vm.preguntainvalida = [];
    	vm.idins = $state.params.idins;
		vm.nivel = $state.params.nivel;
    	vm.contain = contain;
        vm.menu=menu;
        vm.msjCargando=true;
		vm.tipoauto= $state.params.tipoauto;
		vm.resetearResDePregDepediente = resetearResDePregDepediente;
		vm.respuestaCheckABoolean = respuestaCheckABoolean;
		vm.deshabilitar = deshabilitar;
		vm.validarPreguntayRespuestaDependiente = validarPreguntayRespuestaDependiente;
		vm.validarCheck = validarCheck;
		vm.valido = false;
		vm.validoCheck = false;
		vm.mensajeCheck = null;
		vm.preguntainvalidaCheck = [];
		vm.tipo = tipo;
		
        loadCuestionario();
    	
        function loadCuestionario(){
        	CuestionarioService.obtener({
        		ambito : $state.params.ambito, 
        		profesor : $state.params.profesor,
        		modelo: $state.params.modelo,
        		nivel: $state.params.nivel,
				tipoauto: $state.params.tipoauto
            }, onSuccess, onError); 
			
        }       

        function onSuccess(data, headers) { 
        	vm.msjCargando=true;
            vm.resuelto = data;
			init();
        }
        
        function onError(error) {
        	vm.msjCargando=false;
            AlertService.error(error.data.message);
        }
        
		function init(){
			var grupo = vm.resuelto.grupoPreguntasForUI;
			var cuestionario = vm.resuelto.cuestionarioResuelto;
			for (var i = 0; i < grupo.length; i++) {
				for (var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++) {
					for (var h = 0; h < cuestionario.respuestasPregunta.length; h++) {
						if (cuestionario.respuestasPregunta[h].pregunta.id == grupo[i].preguntasWrapperForUI[j].pregunta.id &&
							grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'CheckBox'
						) {
							grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada = vm.respuestaCheckABoolean(grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada);

						}
					}
				}
			}
		}
		
        function save() {
        	var grupo = vm.resuelto.grupoPreguntasForUI;
        	var cuestionario = vm.resuelto.cuestionarioResuelto;

			vm.validarseccion(grupo.length-1);
			vm.validarCheck(grupo.length-1);

			if(vm.valido && vm.validoCheck){
	        	for(var i = 0;i < grupo.length; i++){
	        		for(var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++){
	        			for(var h = 0; h < cuestionario.respuestasPregunta.length; h++){
	        				if(cuestionario.respuestasPregunta[h].pregunta.id == grupo[i].preguntasWrapperForUI[j].pregunta.id){
	        					if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'RadioButton'){
	        						cuestionario.respuestasPregunta[h].respuestaSeleccionada =grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
	            				}
	        					if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'TextArea'){
	        						cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
	            				}
	        					if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'Escala'){
	        						cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
	            				}
								if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'CheckBox'){
									cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
								}
	        				}
	        			}	
	        		}
	        	}
				CuestionarioService.save(cuestionario, onSaveSuccess, onSaveError);
			}
            
        }
        
        function onSaveSuccess(result) {
            $scope.$emit('sideApp:usuarioUpdate', result);
            $state.go('docente');
        }
        
        function onSaveError(error) {
            AlertService.error(error.data.message);
            $state.go('docente',{}, {reload: true});
        }
        
        function anterior(indice){
       		vm.show = indice;
       		vm.mensaje = null;
			vm.mensajeCheck = null;
       		vm.valido = null;
			vm.validoCheck = null;
        	
        }
        function siguiente(indice){
        	vm.validarseccion(indice);
			vm.validarCheck(indice);
        	if(vm.valido&& vm.validoCheck)
        		vm.show = indice+2;
        }
		
        function validarseccion(seccion){
			var grupo = vm.resuelto.grupoPreguntasForUI;
			var cuestionario = vm.resuelto.cuestionarioResuelto;
			var valido = true;
			var mensaje = null;
			var k = 0;
			vm.preguntainvalida = [];
			var index =0;
				for(var j = 0; j < grupo[seccion].preguntasWrapperForUI.length; j++){
					for(var h=0; h < cuestionario.respuestasPregunta.length; h++){
						if(
							grupo[seccion].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta != 'CheckBox' &&
							
							(
								grupo[seccion].preguntasWrapperForUI[j].pregunta.obligatoria || 
								!deshabilitar(grupo[seccion].preguntasWrapperForUI[j].pregunta.id,grupo[seccion].preguntasWrapperForUI[j].pregunta.preguntaActivador,grupo[seccion].preguntasWrapperForUI[j].pregunta.opcionpreguntaactivador)
							) && 
							cuestionario.respuestasPregunta[h].pregunta.id==grupo[seccion].preguntasWrapperForUI[j].pregunta.id){
							if(grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == null ||
								(
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'boolean' &&
									    grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == false
								) ||
								(
									grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada != null &&
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'string' &&
									grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada.trim() == ''
								)
							){
								valido = false;
								vm.preguntainvalida[index] = grupo[seccion].preguntasWrapperForUI[j].pregunta.id;
								index++;
							}
						}
					}
				}
				if(!valido){
					mensaje="No has contestado todas las preguntas de esta sección.";
				}
				vm.valido = valido;
				vm.mensaje = mensaje;
        }
        
		function validarCheck(seccion){
			var grupo = vm.resuelto.grupoPreguntasForUI;
			var min = grupo[seccion].grupoPreguntas.min;
			var max = grupo[seccion].grupoPreguntas.max;
			vm.preguntainvalidaCheck = [];
			if(min != null){
				var aux = 0;
				var cuestionario = vm.resuelto.cuestionarioResuelto;
				var valido = false;
				var mensaje = null;
				var index =0;
				for(var j = 0; j < grupo[seccion].preguntasWrapperForUI.length; j++){
					for(var h=0; h < cuestionario.respuestasPregunta.length; h++){
						if(cuestionario.respuestasPregunta[h].pregunta.id==grupo[seccion].preguntasWrapperForUI[j].pregunta.id &&
							grupo[seccion].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'CheckBox'
						){
							vm.preguntainvalidaCheck[index] = grupo[seccion].preguntasWrapperForUI[j].pregunta.id;
							
//							console.log("respuestaSeleccionada: "+grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada);
							if(grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == null ||
								(
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'boolean' &&
								    grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == false
							 	) ||
								(
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'string' &&
									grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == "false"
								) 
								//No considerar a las preguntas string en un check
							){
								index++;
							}else{
								aux++;
							}
						}
					}
				}
				
				var tp = grupo[seccion].preguntasWrapperForUI[0].pregunta.preguntaActivador !=null? grupo[seccion].preguntasWrapperForUI[0].pregunta.preguntaActivador.tipoPregunta.tipoPregunta:null;

				var idpa = grupo[seccion].preguntasWrapperForUI[0].pregunta.preguntaActivador !=null? grupo[seccion].preguntasWrapperForUI[0].pregunta.preguntaActivador.id : null;

				var opa = grupo[seccion].preguntasWrapperForUI[0].pregunta.opcionpreguntaactivador != null? grupo[seccion].preguntasWrapperForUI[0].pregunta.opcionpreguntaactivador.respuestaString:null;
//				console.log("Validar Check");
				var auxVal = tp!=null ? idpa != null? opa != null ? validarPreguntayRespuestaDependiente(idpa,opa,tp):true:true:true;
				
//				console.log(aux);
//				console.log(min);
//				console.log(max);
//				console.log(auxVal);
				if(aux>=min && aux<=max || !auxVal){
					vm.preguntainvalidaCheck = [];
					valido = true;
				}else{
//					console.log("paseeee");
					mensaje = "Selecciona mínimo "+min+" y máximo "+max+" elementos";
				}
				
				vm.validoCheck = valido;
				vm.mensajeCheck = mensaje;
			}else{
				vm.validoCheck = true;
			}
		}
		
        function contain(idpregunta){
        	var invalido = false;
			var index = 0;
        	for(index = 0;index < vm.preguntainvalida.length; index++){
        		if(vm.preguntainvalida[index] == idpregunta){
        			invalido = true;
        			break;
        		}
        	}
			if(!invalido){
				for(index = 0;index < vm.preguntainvalidaCheck.length; index++){
					if(vm.preguntainvalidaCheck[index] == idpregunta){
				    	invalido = true;
				        break;
				    }
				}
			}
        	return invalido;
        }
		
        function menu(){
        	$state.go("docente");
        }
		
		function resetearResDePregDepediente(preguntaId){
//			console.log("Entrando a resetearResDePregDepediente");
			var grupo = vm.resuelto.grupoPreguntasForUI;
			
			for(var i = 0; i < grupo.length; i++){
				for(var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++){
					if(grupo[i].preguntasWrapperForUI[j].pregunta.preguntaActivador !=null && 
						grupo[i].preguntasWrapperForUI[j].pregunta.preguntaActivador.id==preguntaId){
//						console.log("Pregunta: "+preguntaId);
						// Inicio metodo recursivo	
						resetearResDePregDepediente(grupo[i].preguntasWrapperForUI[j].pregunta.id);
						// Fin metodo recursivo		
						grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada=null;
					}
				}
			}

		}
		
		function respuestaCheckABoolean(respuestaCheck){
			let respuesta = (respuestaCheck == true || respuestaCheck == "true" ? true : false);
			return respuesta;
		}

		function deshabilitar(preguntaid,preguntaActivador,opcionpreguntaactivador){
//			console.log("-----------------------");
//			console.log("Entrando a deshabilitar");
			var boolVar = true;
			if( (preguntaActivador == null && opcionpreguntaactivador == null) ||
				(   
					preguntaActivador != null && opcionpreguntaactivador != null &&
					vm.validarPreguntayRespuestaDependiente(preguntaActivador.id,opcionpreguntaactivador.respuestaString,preguntaActivador.tipoPregunta.tipoPregunta)
				) ){
					boolVar = false;
				}
//				console.log("preguntaid "+preguntaid);
//				console.log("deshabilitar? "+boolVar);
			return boolVar;
		}

		function validarPreguntayRespuestaDependiente(idPregActivador,respuestaStringActivador,tipoPregunta){
//			console.log("Entrando a validarPreguntayRespuestaDependiente");
			var grupo = vm.resuelto.grupoPreguntasForUI;
			
			var aux = false;
			
			for(var i = 0; i < grupo.length; i++){
				for(var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++){
					if(grupo[i].preguntasWrapperForUI[j].pregunta.id == idPregActivador ){ 		
						if(grupo[i].preguntasWrapperForUI[j].pregunta.id == idPregActivador){
							if(tipoPregunta == 'CheckBox'){
//								console.log("TipoPreguntaActivador es check");
//								console.log("Tipo de respuestaStringActivador "+respuestaStringActivador);
//								console.log(typeof respuestaStringActivador);
//								console.log("Tipo de respuestaSelect "+ grupo[i].preguntasWrapperForUI[j].respuesta);
//								console.log(grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada);
//								console.log(typeof grupo[i].preguntasWrapperForUI[j].respuesta);
								var boolVar = Boolean(respuestaStringActivador);
								
								if(grupo[i].preguntasWrapperForUI[j].respuesta != null && Boolean(grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada) == boolVar){
									aux=true;
									break;	
								}
							}else{
								if(grupo[i].preguntasWrapperForUI[j].respuesta != null && grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == respuestaStringActivador){
									aux=true;
									break;	
								}
							}
						}
					}		
				}
			}
//			console.log("valor:"+aux);
			return aux;      	
		}
		
		function tipo(tipo){
			return typeof tipo;
		}
    }
})();
